import React, { useState, useEffect } from "react";

// components 
import { CircularProgress, TextField } from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import Autocomplete from '@material-ui/lab/Autocomplete';
import ModalMessage from "../modals/ModalMessage";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";

// styles
import useStyles from "./styles";
import useStylesTable from "./styles";
import config from "../../config";

export default function InitInventory() {
  const classes = useStyles();
  const classesTable = useStylesTable();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [products, setProducts] = useState([]);
  const [autocompleteKey, setAutocompleteKey] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalMessage, setShowModalMessage] = useState(false);
  const [keyTable, setKeyTable] = useState(0);
  const [isProductExist, setIsProductExist] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const [keyButton, setKeyButton] = useState(1);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const closeModalMessage = e => {
    setShowModalMessage(false);
  }

  const fechGetProducts = async () => {
    fetch(baseUrl + "products",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data.error != null) {
          setShowModal(true);
        } else {
          setAllProducts(data);
        }
      })
      .catch(error => null);
  }

  useEffect(() => {
    fechGetProducts();
  }, []);

  const onSavePurchase = async e => {
    e.preventDefault();
    setIsLoading(true);
    var list = [];

    products.map((item) => {
      list.push({
        productId: item.idProduct, amount: item.stock, price: item.totalCost, cost: item.cost
      });
    });

    const initInventory = {
      initInventoryList: list
    };
    
    const response = await fetch(baseUrl + "createInitInventory", {
      method: 'POST',
      headers: {
        'Accept': 'application/json', 'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("token")
      },
      body: JSON.stringify(initInventory)
    });

    const json = await response.json();
    if (json.message == "Ok") {
      setProducts([]);
      setAutocompleteKey(0);
      setKeyButton(0);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    } else {
      if (json.message == "Access is denied") {
        setShowModal(true);
      }
    }

    setIsLoading(false);
  }

  const onDelete = (property) => (event) => {
    var indexProduct = -1;
    var subTotal = 0;
    var iva = 0;

    products.map((item) => {
      if (item.id == property) {
        indexProduct = products.indexOf(item);
      }
    });

    if (indexProduct > -1) {
      if (products.length == 1) {
        setProducts([]);
      } else {
        setProducts(list);
        var list = [];
        products.map((item) => {
          if (item.id != property) {
            list.push(item);
          }
        });

        setProducts(list);
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          subTotal = Number(subTotal) + Number(item.totalCost);
        }
        iva = parseFloat(subTotal) * .16;
      }
      setKeyTable(keyTable + 1);
    }

    setKeyButton(keyButton + 1);
  };

  const onTagsChange = (event, values) => {
    if (values != null) {
      var product = {
        "id": values.id,
        "idProduct": values.id,
        "name": values.name,
        "cost": null,
        "totalCost": 0,
        "stock": null
      };

      if (products.length > 0) {
        var existProduct = false;

        products.map((item) => {
          if (item.id == product.id) {
            existProduct = true;
          }
        });

        if (existProduct) {
          setIsProductExist(true);
          setShowModalMessage(true);
        } else {
          const allList = products;
          allList.push(product);
          setProducts(allList);
        }
      } else {
        const allList = products;
        allList.push(product);
        setProducts(allList);
      }
    }

    setAutocompleteKey(autocompleteKey + 1);
    setKeyButton(keyButton + 1);
  }

  const onChangeQuantity = (property) => (event) => {
    var value = event.target.value;

    for (var i = 0; i < products.length; i++) {
      var item = products[i];
      var indexProduct = products.indexOf(item);

      if (item.id == property) {
        var product;

        if (item.cost != null) {
          product = {
            "id": item.id,
            "idProduct": item.id,
            "name": item.name,
            "cost": item.cost,
            "totalCost": (parseFloat(value) * parseFloat(item.cost)).toFixed(2),
            "stock": value,
          }
        } else {
          product = {
            "id": item.id,
            "idProduct": item.id,
            "name": item.name,
            "cost": item.cost,
            "totalCost": item.totalCost,
            "stock": value,
          }
        }

        const allList = products;
        allList[indexProduct] = product;
        setProducts(allList);
        i = products.length;
      }
    }

    setKeyButton(keyButton + 1);
  }

  const onChangeCost = (property) => (event) => {
    var value = event.target.value;

    if (value == "") {
      value = 0;
    }

    for (var i = 0; i < products.length; i++) {
      var item = products[i];
      var indexProduct = products.indexOf(item);

      if (item.id == property) {
        var product = {
          "id": item.id,
          "idProduct": item.id,
          "name": item.name,
          "cost": Number(value),
          "totalCost": (parseFloat(item.stock) * parseFloat(value)).toFixed(2),
          "stock": item.stock,
        }

        const allList = products;
        allList[indexProduct] = product;
        setProducts(allList);
        i = products.length;
      }
    }

    setKeyButton(keyButton + 1);
  }

  return (
    <>
      {isProductExist ? (
        <ModalMessage
          isOpen={showModalMessage}
          closeModal={closeModalMessage}
        />
      ) : (
        <></>
      )}

      <div className={classes.div} >
        <Autocomplete
          key={autocompleteKey}
          options={allProducts}
          freeSolo
          getOptionLabel={option => option.name}
          onChange={onTagsChange}
          openText={"Abrir"}
          closeText={"Cerrar"}
          clearText={"Limpiar"}
          noOptionsText={"Sin resultados"}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              placeholder={"Buscar producto"}
              style={{
                border: '0px',
                backgroundColor: "#FFFFFF",
                borderRadius: '100px',
                marginLeft: '8px',
                width: '350px',
                outlineColor: "#FFFFFF",
              }}
            />
          )}
        />
        <div className={classes.divSearch} >
          <Icons.Search classes={{ root: classes.searchIconProduct }} />
        </div>
      </div>

      <div style={{ marginTop: "60px" }}></div>
      <div className={classesTable.divCard} >
        <Table className="mb-0" key={keyTable}>
          <TableHead>
            <TableRow className={classesTable.root} >
              <TableCell>NOMBRE</TableCell>
              <TableCell>CANTIDAD</TableCell>
              <TableCell>PRECIO DE COMPRA</TableCell>
              <TableCell>TOTAL</TableCell>
              <TableCell>ACCIÓN</TableCell>
              {/*{keys.map(key => (
                    <TableCell key={key}>{key}</TableCell>
                  ))}*/}
            </TableRow>
          </TableHead>
          <TableBody>
            {products.map(({ id, name, cost, totalCost, stock }) => (
              <TableRow key={id}>
                <TableCell className={classesTable.tableTextStyle} >{name}</TableCell>
                <TableCell className={classesTable.tableTextStyle} >
                  <TextField
                    InputProps={{
                      classes: {
                        focused: classes.textBorderMembership,
                        input: classes.inputNumberPurchase,
                      },
                      inputProps: {
                        min: 0
                      }
                    }}
                    value={stock}
                    onChange={onChangeQuantity(id)}
                    placeholder={"1"}
                    type={"number"}
                    onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                    style={{ width: '70%' }}
                    inputStyle={{ width: '70%' }}
                  />
                </TableCell>
                <TableCell className={classesTable.tableTextStyle} >
                <div style={{ display: "flex" }}>
                    <p style={{ fontSize: "16px", marginTop: "8px" }}> $ </p>
                    <TextField
                      InputProps={{
                        classes: {
                          focused: classes.textBorderMembership,
                          input: classes.inputNumberPurchase,
                        },
                        inputProps: {
                          min: 0
                        }
                      }}
                      value={cost}
                      onChange={onChangeCost(id)}
                      placeholder={"1"}
                      type={"number"}
                      onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                      style={{ width: '70%' }}
                      inputStyle={{ width: '70%' }}
                    />
                  </div>
                </TableCell>
                <TableCell className={classesTable.tableTextStyle} > {"$ " + Number(totalCost).toFixed(2)} </TableCell>
                <TableCell className={classesTable.tableTextStyle} >
                  <div className={classesTable.divActionButton}>
                    <Delete className={classesTable.iconAcctionInventory}
                      onClick={onDelete(id)}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <div className={classes.divButton}>
        {isLoading ? (
          <div className={classes.loginLoader} >
            <CircularProgress size={26} />
          </div>
        ) : (
          <button
            key={keyButton}
            className={products.length > 0 ?
              classes.enableButton : classes.disableButton}
            disabled={!(products.length > 0)}
            onClick={onSavePurchase}
          >GUARDAR</button>
        )}
      </div>
    </>
  );
}
